import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter } from "react-router-dom";

import App from "./App.tsx";
import { store, persistor } from "./store";
import { queryClient } from "./lib/queryClient";

// Import global styles
import "./styles/globals.css";
import "./styles/components.css";

// Register service worker for Google Maps caching
if ("serviceWorker" in navigator && process.env.NODE_ENV === "production") {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then(() => {
        console.log(
          "✅ [SW] Service Worker registered for Google Maps caching"
        );
      })
      .catch((error) => {
        console.error("❌ [SW] Service Worker registration failed:", error);
      });
  });
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  // NOTE: StrictMode disabled during messaging development to prevent double socket connections
  // React StrictMode intentionally double-mounts components in development to detect side effects
  // This causes multiple socket connections. Re-enable before production build.
  <React.StrictMode>
  <Provider store={store}>
    <PersistGate loading={<div>Loading...</div>} persistor={persistor}>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </PersistGate>
  </Provider>
  </React.StrictMode>
);
